<template>
  <SfModal
    v-if="modalOpen"
    content-class-name="sf-pad-3"
    size="xs"
    @close="close"
  >
    <template #title>{{
      I18n.t(
        'firms.internal_invoices.content_product.license_year_for_products'
      )
    }}</template>

    <template #body>
      <div
        class="sf-layer-rounded sf-layer-border sf-bg-white sf-overflow-hidden"
      >
        <div class="sf-modal-content sf-pad-3">
          <table class="sf-table">
            <thead>
              <tr>
                <th class="sf-font-medium sf-align-l" style="width: 100px">
                  {{
                    I18n.t('firms.internal_invoices.content_product.product')
                  }}
                </th>
                <th class="sf-font-medium sf-align-l" style="width: 100px">
                  {{ I18n.t('firms.internal_invoices.license_year') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(value, key) in licenses"
                :key="key"
                class="sf-layer-border-top"
              >
                <td class="sf-pad-v-1">{{ key }}</td>
                <td class="sf-pad-v-1">{{ value[0] + ' - ' + value[1] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </SfModal>
</template>

<script>
import { SfModal } from '@app/shared/vue/components/sf-modal'

export default {
  components: {
    SfModal,
  },

  data() {
    return {
      modalOpen: false,
      licenses: {},
    }
  },

  methods: {
    openModal(context) {
      this.licenses = context.licenses
      this.modalOpen = true
    },

    close() {
      this.modalOpen = false
    },
  },
}
</script>
